import { createSlice, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import {IIndexable} from "../../../domain/interfaces";
import {getJSONFromHtml} from "../../../domain/common";
import {
    CategoryIsMandatory,
    SBL_BuilderPage,
    SBL_BuilderPageMain,
    SBL_BuilderPagePreset
} from "../interfaces";


export interface StateInterface extends IIndexable{
    SBL_BuilderPage: SBL_BuilderPage;
    SBL_BuilderPagePresetList:SBL_BuilderPagePreset[];
    PresetGroupList:SBL_BuilderPagePreset[];
    CategoryList:SBL_BuilderPageMain[];
    ProductList:SBL_BuilderPageMain[];
    ImageCDNDomain:string;
    UserState_SystemType:string;
    UserState_SelectedProducts: SBL_BuilderPageMain[];
    UserState_HiddenProductIds: number[];
    UserState_CategoriesIsMandatory:CategoryIsMandatory[];
    UserState_SoftwareWasChosen:boolean;
    UserState_CableCount:number;
    UserState_AllMandatoryAdded:boolean;
    UserState_Cost:number;
    UserState_CostLoading:boolean;
    //https://wavesaudio.atlassian.net/browse/DSWEB-1021
    UserState_NumberOfInputs:number;
    PageWasLoad:boolean;

}
// initial state
const initialState: StateInterface = {
    SBL_BuilderPage: (getJSONFromHtml(document.getElementById('system-builder-data')) as SBL_BuilderPage),
    SBL_BuilderPagePresetList: ((getJSONFromHtml(document.getElementById('system-builder-data')).sbl_BuilderPagePresetList) as SBL_BuilderPagePreset[]),
    PresetGroupList:((getJSONFromHtml(document.getElementById('system-builder-data')).sbl_BuilderPagePresetList) as SBL_BuilderPagePreset[]).filter(
        (item, i, arr) => arr.findIndex(t => t.presetID === item.presetID) === i),
    CategoryList : ((getJSONFromHtml(document.getElementById('system-builder-data')).sbl_BuilderPageMainList) as SBL_BuilderPageMain[]).filter(
        (item, i, arr) => arr.findIndex(t => t.categoryID === item.categoryID) === i),
    ProductList:(getJSONFromHtml(document.getElementById('system-builder-data')).sbl_BuilderPageMainList) as SBL_BuilderPageMain[],
    ImageCDNDomain : (document.getElementById('img-cdn-domain')?.textContent || '')?.trim().toLowerCase(),
    UserState_SystemType:"",
    UserState_SelectedProducts:[] as SBL_BuilderPageMain[],
    UserState_HiddenProductIds:[] as number[],
    UserState_CategoriesIsMandatory:[] as CategoryIsMandatory[],
    UserState_SoftwareWasChosen:false,
    UserState_CableCount:0,
    UserState_AllMandatoryAdded:false,
    UserState_Cost:0,
    UserState_CostLoading:false,
    UserState_NumberOfInputs:0,
    PageWasLoad:false


}
// the main slice
const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {
        main(state, action) {
            return {
                ...state,
                ...action.payload,
            };
        },
    },
});

const store = configureStore({
    reducer: rootSlice.reducer,
});

export const rootActions = rootSlice.actions;
export default store;

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 * https://redux.js.org/recipes/usage-with-typescript
 */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://redux.js.org/recipes/usage-with-typescript
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
